export default {
    About: '大赛简介',
    Events: '赛事动态',
    ProductsShow: '作品展示',
    Material: '资料下载',
    Participantlogin: '参赛登录',
    Judgelogin: '评委登录',
    Introduction: '大赛简介',
    EntryInformation: '参赛须知',
    Participation: '我要参赛',
    Scopeofentriessubmitted: '参赛要求',
    Awardssetting: '奖项设置',
    DocumentDownload: '资料下载',
    Contactthetheorganizingcommittee: '联系我们',
    tis:'中国自行车电动自行车设计大赛报名通道已关闭',
    Guidanceunit: '指导单位',
    Organizers: '主办单位',
    CoOrganizer: '协办单位',
    Organizer: '承办单位',
    SupportUnits: '支持单位',
    Juries: '评审委员会',
    SupportMedia: '支持媒体',
    SelectionPurpose: '评选宗旨',
    Candidates: '参选范围',
    Candidatesbody: '由企业（个人）自主研发设计，并已在最近三年内实现量产，在中国市场或海外市场上市的自行车整车、电动自行车整车、自行车零部（配）件、电动车零部（配）件及相关配套产品。',
    Conditions: '参评条件',
    Conditionsbody: '参选产品必须同时满足以下要求：\n1、2020-2022年研制成功并上市的产品；\n 2、全新产品，或有重大变化的升级换代产品； \n3、知识产权清晰、产品设计新颖、结构合理、性能优越、技术先进适用； \n4、具备必要的标准、工艺规程、安全规程、操作规程及工装、检测手段；\n 5、达到设计要求，符合国家标准、行业标准或用户要求，技术水平达到国际、国内先进。',
    Costs: '参评费用',
    Costsbody: '1、参评费：免费。\n2、所有参评者发生的交通、通讯、邮寄、宣传及产品运输等费用自理。',
    Reviewprinciple: '评审原则',
    Reviewprinciplebody: '创新要素、技术含量、低碳节能、市场空间、使用友善、成本优势、必要审美、社会责任。',
    Reviewprocess: '评审程序',
    Reviewprocessbody: '1、初评：2023年6月15日，评审委员会从所有参评产品中按标准评审出入围产品，名单于2023年7月20-31日在www.cbda.otobtb.com网站和中国自行车微信号上公示，并接受社会各界就作品信息的真实性、创新性以及权属问题等各方面的广泛质询与建议；\n2、网上公众投票评选：2023年7月20-31日对入围产品进行公示同时接受公众投票评选；\n3、评审委员会复评：2023年9月1日，评审委员会成员对已入围的产品进行复评，同时产生评选结果。\n4、网络投票占10%，评审委员会审议占90%；最终评审结果于2023年12月x日颁奖典礼现场由颁奖嘉宾揭晓。',
    Entryway: '参选方式',
    Entrywaybody: '1、企业、代理商自荐；\n2、专业机构、专家推荐；\n3、各省市行业自行车协会推荐、俱乐部推荐、专业媒体推荐。',
    Registration: '报名时间',
    Registrationbody: '2022年9月1日-2023年2月28日，资料提交截止日为2023年3月10日。',
    Productssubmitted: '作品提交',
    Productssubmittedbody: '请如实填写作品信息，便于评委会了解评价参赛作品',
    Company: '参赛单位名称或个人姓名:',
    Companyplaceholder: '参赛单位名称或个人姓名',
    ProductName: '作品名称:',
    ProductNameplaceholder: '请输入作品名称',
    ProductBrand: '作品品牌:',
    ProductBrandplaceholder: '请输入作品品牌',
    Producttype: '作品类型:',
    Producttypeplaceholder: '请输入作品类型',
    Productsize: '作品尺寸:',
    Productsizeplaceholder: '请输入作品尺寸（mm）',
    NetWeight: '作品净重:',
    NetWeightplaceholder: '请输入作品净重（kg）',
    Price: '作品售价:',
    Priceplaceholder: '请输入作品售价（人民币）',
    Mainpicturesofproducts: '作品图片(3-6张实物图或效果图(300dpi,JPG格式)):',
    Mainpicturesofproductsplaceholder: '请上传作品图片',
    Productapplicationscenariopictures: '作品使用场景图片:',
    Productapplicationscenariopicturesplaceholder: '请上传使用场景图片',
    Schematicdiagramofkeypointsofproductdesign: '作品设计重点示意图:',
    Schematicdiagramofkeypointsofproductdesignplaceholder: '请上传作品设计重点示意图',
    Videos: '作品相关视频(mp4格式,时长2分钟内,分辨率1280*720):',
    Videosplaceholder: '请上传作品相关视频',
    reVideosplaceholder: '重新上传作品视频',
    Producttestingreport: '作品检测报告:',
    Producttestingreportplaceholder: '请上传作品检测报告',
    Productdescription: '作品描述:',
    Productdescriptionplaceholder: '请输入作品描述',
    Designhouse: '设计公司:',
    Designhouseplaceholder: '请输入设计公司',
    Manufacturingcompany: '制造公司:',
    Manufacturingcompanyplaceholder: '请输入制造公司',
    PatentNumber: '专利号:',
    PatentNumberplaceholder: '请输入专利号',
    Certificateforinventorspatentright: '发明专利证书:',
    Certificateforinventorspatentrightplaceholder: '请上传发明专利证书',
    UtilityModelPatent: '实用新型专利:',
    UtilityModelPatentplaceholder: '请上传实用新型专利证书',
    DesignPatent: '外观设计专利:',
    DesignPatentplaceholder: '请上传外观设计专利证书',
    DescriptionofSpecialFunctions: '特殊功能描述:',
    DescriptionofSpecialFunctionsplaceholder: '请输入特殊功能描述',
    SpecialMaterials: '特殊材料:',
    SpecialMaterialsplaceholder: '请输入特殊材料',
    Specialprocess: '特殊工艺:',
    Specialprocessplaceholder: '请输入特殊工艺',
    OtherInnovationDescriptions: '其他创新描述:',
    OtherInnovationDescriptionsplaceholder: '请输入其他创新描述',
    Aerodynamics: '空气动力学:',
    Aerodynamicsplaceholder: '请输入空气动力学',
    Ergonomics: '人体工程学:',
    Ergonomicsplaceholder: '请输入人体工程学',
    Lightweightdescription: '轻量化描述:',
    Lightweightdescriptionplaceholder: '请输入轻量化描述',
    SpecialMaterials: '特殊材料:',
    SpecialMaterialsptionplaceholder: '请输入特殊材料',
    Weightcarryingability: '载重性:',
    Weightcarryingabilityptionplaceholder: '请输入载重性',
    Convenience: '便利性:',
    Convenienceplaceholder: '请输入便利性描述',
    Security: '安全性:',
    Securityplaceholder: '请输入安全性描述',
    EnvironmentalPerformance: '环保性:',
    EnvironmentalPerformanceplaceholder: '请输入环保性描述',
    Adaptabilitytospecialroadconditions: '特殊路况适应性:',
    Adaptabilitytospecialroadconditionsplaceholder: '请输入特殊路况适应性描述',
    DescriptionofOtherFeatures: '其他特点描述:',
    DescriptionofOtherFeaturesplaceholder: '请输入其他特点描述',
    Comfort: '舒适性描述:',
    Comfortplaceholder: '请输入舒适性描述',
    SpecialDesign: '特殊设计描述:',
    SpecialDesignplaceholder: '请输入特殊设计描述',
    informationsubmission: "信息提交",
    RightsandObligations: '权利与义务',
    RightsandObligationsbody: "1、所有参评者享有同等参与评奖、监督、建议的权利，组委会负有被监督、听取建议的义务；\n2、参评者无偿地、不可撤销地授权组委会对所有获奖产品、品牌或组委会认为有必要的其他参评产品、品牌，以组委会认为合适的方式进行展览、公示、宣传、编辑出版或编印；\n3、所有参评者不得要求组委会退回所提交的参评产品、品牌的参评资料；无权向主办单位、承办单位及组委会主张获得任何补偿、对价、报酬、费用承担，亦无权要求享有任何特殊权利或分享组委会因相关活动所获取的任何权益、收益；\n4、如未能评选出合适的得奖产品、品牌，组委会保留不颁发任何一个奖项的权利；\n5、参评者应自行承担其参加本次评选的全部责任，如发现参评者、参评产品、品牌有不符合参评条件的情形，组委会有权在评选任一阶段取消其参评资格，收回其所获之奖项，由此造成组委会损失的，概由参评者承担；\n6、参评者参加本次评选即视为已完全了解并完全接受包括本规则及其解释在内的各项条款。",
    DisputeSettlement: "争议处理",
    DisputeSettlementbody: "1、如参评者之间因为参评事宜发生任何争议，首先应当协商解决。如果各方无法自行解决争议，则组委会可以居中进行调解。调解不成的，各方自行寻求法律途径解决；\n2、如其他方对参评产品、品牌提出知识产权方面的争议，则由参评者自行处理并承担一切法律责任， 如组委会因此而被卷入纠纷，所造成的一切损失，概由参评者承担；\n3、本次评选所涉及的一切活动，均适用于中华人民共和国的法律法规，并依据其进行解释。本评选在征集、参评、展示、宣传等过程中所产生的一切纠纷，均应友好协商解决，协商不成则应提交组委会所在地法院诉讼解决。",
    Validityandinterpretationright: "生效与解释权",
    Validityandinterpretationrightbody: "本规则的解释权及修改权归主办单位。本规则自2022年10月20日起生效。",
    OrganizingCommitteeAward: '组委会大奖:',
    Completebicycle: '自行车整车类:',
    Electricbicycle: "电动自行车整车类:",
    BicycleElectricbicycleparts: "自行车/电动自行车零部件类:",
    GoldAward: '金奖',
    Silveraward: '银奖',
    Bronze: '铜奖',
    Download: '资料下载',
    ContactUs: '联系我们',
    Contact: '联系人',
    Tel: '电话',
    pleaseTel:"请输入电话",
    Fax: '传真',
    Zipcoad: '邮编',
    Emailaddress: '邮箱',
    Address: '地址',
    ChinaBikeAssociation: "中国自行车协会",
    GuangzhouMunicipality: '广州市人民政府',
    ChinaNationalLightIndustryCouncil: '中国轻工业联合会',
    NationalBicycleIndustryInformationCenter: '全国自行车信息中心',
    Development: '翔若轩（上海）文化发展有限公司',
    CountryRegion: '国家/地区',
    Account: '手机号',
    Captcha: '验证码',
    ObtainCaptcha: '获取验证码',
    Password: '密码',
    ConfirmPassword: '确认密码',
    digipasswordcassensitive: '6-16位密码，区分大小写',
    Change: "确认修改",
    wonderfulpictures: '精彩图片',
    Worksshowandvote: '作品展示',
    toauditing: '去审核',
    Voting: '投票',
    changePassword: '修改密码',
    Reviewentries: '审核参赛作品',
    Reviewprogressofparticipatingproducts: '参赛作品审核进度',
    personalcenter: '个人中心',
    Participantlogin2: '已登录参赛账号',
    Judgelogin2: '已登录评委账号',
    Forgotpassword: "忘记密码?",
    Noaccountyet: "还没有参赛账号?",
    Registernow: "马上注册!",
    accountlogin1: "参赛者账号",
    accountlogin2: "评委账号",
    login: "登录",
    Productsubmitted: '作品已提交',
    Preliminaryreviewpassed: '初审通过',
    selectedforthecompetition: "作品已被选入参赛",
    secondsleft: '秒后重新发送',
    Registeranaccount: '账号注册',
    Phonenumber: '手机号',
    Phonenumberbody: '请输入手机号',
    pleaseenterverificationcode: '请输入验证码',
    Sendtheverificationcode: '发送验证码',
    PleaseenterEmail: '请输入E-mail',
    Pleaseenterpassword: "请输入密码",
    Pleaseconfirmyourpassword: '请确认密码',
    readandaccept: '阅读并接受',
    RegistrationEntryAgreement: '注册/参赛协议，隐私策略',
    LegalNotices: '法律声明',
    register: '注册',
    pvai: '作品视频与图片',
    Functionality: '功能性',
    adoptBtn: '通过',
    refuseBtn: '拒绝',
    loginOut: '退出登录',
    ContestScope:"参赛范围:",
    DesignCompletionDate:"设计完成日期:",
    CopyrightRegistration:"是否已进行版权登记:",
    TimeToMarket:"作品上市时间:",
    PatentApplication:"是否已申请专利:",
    postalAddress:"通讯地址:",
    ContactName:"联系人姓名:",
    MobilePhone:"移动电话:",
    job:"职务:",
    fixedTelephone:"固定电话:",
    email:"电子邮箱:",
    pleaseContestScope:"请输入参赛范围",
    pleaseDesignCompletionDate:"请输入设计完成日期",
    pleaseCopyrightRegistration:"请输入是或否",
    pleaseTimeToMarket:"请输入作品上市时间",
    pleasePatentApplication:"请输入是或否",
    pleasePostalAddress:"请输入通讯地址",
    pleaseContactName:"请输入联系人姓名",
    pleaseMobilePhone:"请输入移动电话",
    pleaseJob:"请输入职务",
    pleaseFixedTelephone:"请输入固定电话",
    pleaseEmail:"请输入电子邮箱",
    companyIntroduction:"参赛单位或个人简介:",
    pleaseCompanyIntroduction:"请输入公司简介或者个人简介",
    personnelInformation:"设计团队人员信息:",
    name:"姓名:",
    pleaseName:"请输入姓名",
    designIntroduction:"设计说明:",
    pleaseDesignIntroduction:"对参赛作品的设计理念、用途、功能进行文字说明,重点描述作品的创新性、实用性、美学效果、人机工学、品质、环保性、经 济性等,限800字以内。",
    yes:"是",
    no:"否",
    pleaseChoose:"请选择",
    hadPost:"您已拥有参赛作品！",
    delete:"删除",
    add:"增加",
    maxLength:"最大字数",
    pictureLength:"请上传3-6张图片",
    files:"作品演示文稿(ppt或pdf):",
    clickUp:"点击上传",
    filesWarn: "请上传作品演示文稿",
    pleasePersonnelInformation: "请填写设计团队信息",
    judgeCant:"评委无需参赛",
    videoNoFinish:"视频还未上传成功",
    passed:"已通过",
}